<template>
    <div id="allowance-select-wrapper">
        <div style="overflow-y:auto; max-height: 40px;" :style="1 ? 'padding: 0;margin-bottom: 5px;' : ''">
            <span id="allowance_name_modal" style="font-size: 1.5rem">{{headerName}}</span>
        </div>
        <div style="overflow-y:auto; max-height: 55px;" :style="headerRemarks ? 'padding: 5px 0;margin-bottom: 5px;' : ''">
            <div id="allowance_remarks_modal" style="line-height: 1.2;">{{headerRemarks}}</div>
        </div>
        <div :style="rows2 && rows2.length>0 ? 'display: flex; flex-wrap: wrap; justify-content: left;' : ''">
            <div>
                <div :class="isDisplaySearch2 ? 'lg-mt-65px' : ''">
                    <mdb-datatable
                       ref="mdbDatatable"
                       :class="rows2 && rows2.length>0 ? 'col-12 col-xl-8' : ''"
                       :data="{ rows: rows ,columns: columns }"
                       :responsive="responsive"
                       :bordered="bordered"
                       :tfoot="tfoot"
                       :enable-sum-footer="tableProps.enableSumFooter"
                       :searching="searching"
                       :sorting="sorting"
                       :show-edit-column="showEditColumn"
                       :pagination="pagination"
                       :selectable="isSelectable"
                       :max-height="maxHeight"
                       :scroll-y="scrollY"
                       :sticky="sticky"
                       :show-dummy-column="showDummyColumn"
                       :selectable-momentary="selectableMomentary"
                       :multi-selectable="isMultiSelectable"
                       :show-select-checkbox="isShowSelectCheckbox"
                       :striped="striped"
                       v-on:on-row-selected.stop="onRowSelected($event)"
                    />
                </div>
            </div>
            <div class="col">
                <!-- 検索範囲 -->
                <div v-if="isDisplaySearch2" class="d-flex flex-wrap" style="flex: 1 1 auto;">
                    <div class="col-12 max-w-400px mb-10px">
                        <label class="mb-0">検索範囲</label>
                        <div class="d-flex align-items-center">
                            <div :id="'search_start_date_2'" :class='[dateWorkMode2 === "YMD" ? "w-100 max-w-140px mb-10px" : "w-100 max-w-120px mb-10px"]'>
                                <md-datepicker :work-mode="dateWorkMode2" :attr-name="'search_start_date_2'" :ref="'search_start_date_2'" :value="dateFrom2"/>
                            </div>
                            <div class="px-10px mb-10px">
                                ～
                            </div>
                            <div :id="'search_end_date_2'" :class='[dateWorkMode2 === "YMD" ? "w-100 max-w-140px mb-10px" : "w-100 max-w-120px mb-10px"]'>
                                <md-datepicker :work-mode="dateWorkMode2" :attr-name="'search_end_date_2'" :ref="'search_end_date_2'" :value="dateWorkMode2 === 'YMD' ? dateTo2 : dateFrom2"/>
                            </div>
                        </div>
                    </div>
                    <!--検索ボタン-->
                    <div class="col-12 max-w-100px mb-10px">
                        <div class="d-flex h-100 align-items-end justify-content-end">
                            <button :id="'btn-search_2'" type="button" class="btn btn-sm old-btn center-icon-btn m-0">
                                <img class="icon-btn-15" alt="選択表示" src="/images/common/do-search.svg">
                                <span class="w-100">選択表示</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <mdb-datatable
                        v-if="rows2 && rows2.length > 0"
                        :class="rows2 && rows2.length>0 ? 'col-12 col-xl-4' : ''"
                        ref="mdbDatatable2"
                        :data="{ rows: rows2 ,columns: columns2 }"
                        :responsive="responsive2"
                        :bordered="bordered2"
                        :tfoot="tfoot2"
                        :searching="searching2"
                        :sorting="sorting2"
                        :show-edit-column="showEditColumn2"
                        :pagination="pagination2"
                        :selectable="isSelectable2"
                        :max-height="maxHeight2"
                        :scroll-y="scrollY2"
                        :sticky="sticky2"
                        :show-dummy-column="showDummyColumn2"
                        :selectable-momentary="selectableMomentary2"
                        :multi-selectable="isMultiSelectable2"
                        :show-select-checkbox="isShowSelectCheckbox2"
                        :striped="striped2"
                        :enable-sum-footer="isDisplaySearch2 ? true : (enableSumFooter2 ? true : false)"
                        v-on:on-row-selected.stop="onRowSelected2($event)"
                    />
                </div>
<!--                <div v-if="isDisplaySearch2" class="col-12 d-flex flex-wrap flex-row-reverse">-->
<!--                    <div>-->
<!--                        <label class="mb-0">合計点数</label>-->
<!--                        <div class="d-flex align-items-center">-->
<!--                            <div :id="'search_start_date_2'" class="w-100 max-w-140px mb-10px">-->
<!--                                <input type="text" name="sum_score_2" class="form-control text-right" :value="sumScore2" readonly/>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import Datatable from "../CustomMDBVue/Tables/Datatable";
    export default {
        name: "AllowanceSelect",
        props: {
            data: {
                type: [Object, String],
                default: () => ({
                    columns: [],
                    rows: [],
                    rowSelection: [],
                    headerName: "",
                    HeaderRemarks: "",
                })
            },
            editable: {
                type: Boolean,
                default: false
            },
            selectable: {
                type: Boolean,
                default: false
            },
            selectableMomentary: {
                type: Boolean,
                default: false
            },
            multiSelectable: {
                type: Boolean,
                default: false
            },
            showSelectCheckbox: {
                type: Boolean,
                default: false
            },
            autoWidth: {
                type: Boolean,
                default: false
            },
            bordered: {
                type: Boolean,
                default: false
            },
            borderless: {
                type: Boolean,
                default: false
            },
            dark: {
                type: Boolean,
                default: false
            },
            fixed: {
                type: Boolean,
                default: false
            },
            headerColor: {
                type: String
            },
            headerWhite: {
                type: Boolean,
                default: false
            },
            hover: {
                type: Boolean,
                default: false
            },
            maxWidth: {
                type: String
            },
            maxHeight: {
                type: String
            },
            order: {
                type: Array
            },
            pagination: {
                type: Boolean,
                default: true
            },
            responsive: {
                type: Boolean,
                default: false
            },
            responsiveSm: {
                type: Boolean,
                default: false
            },
            responsiveMd: {
                type: Boolean,
                default: false
            },
            responsiveLg: {
                type: Boolean,
                default: false
            },
            responsiveXl: {
                type: Boolean,
                default: false
            },
            scrollY: {
                type: Boolean,
                default: false
            },
            searching: {
                type: Boolean,
                default: true
            },
            sorting: {
                type: Boolean,
                default: true
            },
            striped: {
                type: Boolean,
                default: false
            },
            start: {
                type: String,
                default: '先頭'
            },
            end: {
                type: String,
                default: '最終'
            },
            next: {
                type: String,
                default: '次'
            },
            previous: {
                type: String,
                default: '前'
            },
            arrows: {
                type: Boolean,
                default: false
            },
            display: {
                type: Number,
                default: 5
            },
            defaultRow: {
                type: String,
                default: '-'
            },
            defaultCol: {
                type: String,
                default: 'undefined'
            },
            tfoot: {
                type: Boolean,
                default: true
            },
            reactive: {
                type: Boolean,
                default: false
            },
            refresh: {
                type: Boolean,
                default: false
            },
            time: {
                type: Number,
                default: 5000
            },
            searchPlaceholder: {
                type: String
            },
            entriesTitle: {
                type: String
            },
            noFoundMessage: {
                type: String,
                default: '一致するレコードがありません'
            },
            showingText: {
                type: String,
                default: "表示"
            },
            showEditColumn: {
                type: Boolean,
                default: false
            },
            keyColumn: {
                type: String,
                default: "id"
            },
            editColumnStyle: {
                type: Array,
                default: () => [{'width': '140px', 'min-width': '140px'}]
            },
            displayEditButton: {
                type: Boolean,
                default: true
            },
            displayRemoveButton: {
                type: Boolean,
                default: true
            },
            displayLinkButton: {
                type: Boolean,
                default: false
            },
            showDummyColumn: {
                type: Boolean,
                default: false
            },
            enableSumFooter: {
                type: Boolean,
                default: false
            },
            sticky: {
                type: Boolean,
                default: false
            },
            //2つ目用
            data2: {
                type: [Object, String],
                default: () => ({
                    columns: [],
                    rows: [],
                    rowSelection: [],
                    headerName: "",
                    HeaderRemarks: "",
                })
            },
            editable2: {
                type: Boolean,
                default: false
            },
            selectable2: {
                type: Boolean,
                default: false
            },
            selectableMomentary2: {
                type: Boolean,
                default: false
            },
            multiSelectable2: {
                type: Boolean,
                default: false
            },
            showSelectCheckbox2: {
                type: Boolean,
                default: false
            },
            autoWidth2: {
                type: Boolean,
                default: false
            },
            bordered2: {
                type: Boolean,
                default: false
            },
            borderless2: {
                type: Boolean,
                default: false
            },
            dark2: {
                type: Boolean,
                default: false
            },
            fixed2: {
                type: Boolean,
                default: false
            },
            headerColor2: {
                type: String
            },
            headerWhite2: {
                type: Boolean,
                default: false
            },
            hover2: {
                type: Boolean,
                default: false
            },
            maxWidth2: {
                type: String
            },
            maxHeight2: {
                type: String
            },
            order2: {
                type: Array
            },
            pagination2: {
                type: Boolean,
                default: true
            },
            responsive2: {
                type: Boolean,
                default: false
            },
            responsiveSm2: {
                type: Boolean,
                default: false
            },
            responsiveMd2: {
                type: Boolean,
                default: false
            },
            responsiveLg2: {
                type: Boolean,
                default: false
            },
            responsiveXl2: {
                type: Boolean,
                default: false
            },
            scrollY2: {
                type: Boolean,
                default: false
            },
            searching2: {
                type: Boolean,
                default: true
            },
            sorting2: {
                type: Boolean,
                default: true
            },
            striped2: {
                type: Boolean,
                default: false
            },
            start2: {
                type: String,
                default: '先頭'
            },
            end2: {
                type: String,
                default: '最終'
            },
            next2: {
                type: String,
                default: '次'
            },
            previous2: {
                type: String,
                default: '前'
            },
            arrows2: {
                type: Boolean,
                default: false
            },
            display2: {
                type: Number,
                default: 5
            },
            defaultRow2: {
                type: String,
                default: '-'
            },
            defaultCol2: {
                type: String,
                default: 'undefined'
            },
            tfoot2: {
                type: Boolean,
                default: true
            },
            reactive2: {
                type: Boolean,
                default: false
            },
            refresh2: {
                type: Boolean,
                default: false
            },
            time2: {
                type: Number,
                default: 5000
            },
            searchPlaceholder2: {
                type: String
            },
            entriesTitle2: {
                type: String
            },
            noFoundMessage2: {
                type: String,
                default: '一致するレコードがありません'
            },
            showingText2: {
                type: String,
                default: "表示"
            },
            showEditColumn2: {
                type: Boolean,
                default: false
            },
            keyColumn2: {
                type: String,
                default: "id"
            },
            editColumnStyle2: {
                type: Array,
                default: () => [{'width': '140px', 'min-width': '140px'}]
            },
            displayEditButton12: {
                type: Boolean,
                default: true
            },
            displayRemoveButton2: {
                type: Boolean,
                default: true
            },
            displayLinkButton2: {
                type: Boolean,
                default: false
            },
            showDummyColumn2: {
                type: Boolean,
                default: false
            },
            enableSumFooter2: {
                type: Boolean,
                default: false
            },
            sticky2: {
                type: Boolean,
                default: false
            },
            displaySearch2: {
                type: Boolean,
                default: false
            },
            dateWorkMode2:{
                type: String,
                default: 'YMD'
            },
            dateValueFrom2:{
                type: String,
                default: ''
            },
            dateValueTo2:{
                type: String,
                default: ''
            },
        },
        data() {
            return {
                //1つ目
                updatedKey: null,
                reactiveFlag: false,
                recentSort: null,
                interval: null,
                rows: this.data.rows || [],
                columns: this.data.columns || [],
                options: [10, 25, 50, 100],
                entries: 10,
                pages: [],
                activePage: 0,
                search: '',
                tableProps: {
                    autoWidth: this.autoWidth,
                    bordered: this.bordered,
                    borderless: this.borderless,
                    dark: this.dark,
                    fixed: this.fixed,
                    hover: this.hover,
                    responsive: this.responsive,
                    responsiveSm: this.responsiveSm,
                    responsiveMd: this.responsiveMd,
                    responsiveLg: this.responsiveLg,
                    responsiveXl: this.responsiveXl,
                    striped: this.striped,
                    dtScrollY: this.scrollY,
                    maxHeight: this.maxHeight,
                    sticky: this.sticky && !this.scrollY,
                    enableSumFooter: this.enableSumFooter,
                },
                wrapperStyle: {
                    maxWidth: this.maxWidth ? this.maxWidth : '100%',
                    margin: '0 auto'
                },
                defaultOrder: [],
                rowSelection: this.data.rowSelection || [],
                comp_uuid: '',
                headerName: this.data.headerName,
                headerRemarks: this.data.headerRemarks,
                //2つ目
                updatedKey2: null,
                reactiveFlag2: false,
                recentSort2: null,
                interval2: null,
                rows2: this.data2.rows || [],
                columns2: this.data2.columns || [],
                options2: [10, 25, 50, 100],
                entries2: 10,
                pages2: [],
                activePage2: 0,
                search2: '',
                tableProps2: {
                    autoWidth: this.autoWidth2,
                    bordered: this.bordered2,
                    borderless: this.borderless2,
                    dark: this.dark2,
                    fixed: this.fixed2,
                    hover: this.hover2,
                    responsive: this.responsive2,
                    responsiveSm: this.responsiveSm2,
                    responsiveMd: this.responsiveMd2,
                    responsiveLg: this.responsiveLg2,
                    responsiveXl: this.responsiveXl2,
                    striped: this.striped2,
                    dtScrollY: this.scrollY2,
                    maxHeight: this.maxHeight2,
                    sticky: this.sticky2 && !this.scrollY2,
                    enableSumFooter: this.enableSumFooter2,
                },
                wrapperStyle2: {
                    maxWidth: this.maxWidth2 ? this.maxWidth2 : '100%',
                    margin: '0 auto'
                },
                defaultOrder2: [],
                rowSelection2: this.data2.rowSelection || [],
                comp_uuid2: '',
                headerName2: this.data2.headerName,
                headerRemarks2: this.data2.headerRemarks,
                isSelectable: this.selectable,
                isMultiSelectable: !this.selectable && this.multiSelectable,
                isShowSelectCheckbox: this.showSelectCheckbox,
                isSelectable2: this.selectable2,
                isMultiSelectable2: !this.selectable2 && this.multiSelectable2,
                isShowSelectCheckbox2: this.showSelectCheckbox2,
                isDisplaySearch2: this.displaySearch2,
                dateFrom2: this.dateValueFrom2,
                dateTo2: this.dateValueTo2,
                sumScore2: 0,
            };
        },
        components: {
            Datatable
        },
        methods: {
            onEditButtonClick(event,key) {
                this.$emit('on-edit-button-click', event);
            },
            onRemoveButtonClick(event) {
                this.$emit('on-remove-button-click', event);
            },
            onLinkButtonClick(event) {
                this.$emit('on-link-button-click', event);
            },
            onRowSelected(event){
                this.$emit('on-row-selected', event);
            },
            onRowSelected2(event){
                this.$emit('on-row-selected2', event);
            },
            onUpdate(){
                this.$emit('on-updated');
            },
            formatChange(row, header) {
                let ret = null;
                if (this.$parent.formatChange) {
                    ret = this.$parent.formatChange(row, header)
                } else {
                    ret = row[header];
                }
                return ret;
            },
            log(msg,obj) {
                console.log(msg,obj);
            },
        },
        watch: {
            data(newVal) {
                this.$refs.mdbDatatable.columns = newVal.columns;
                this.$refs.mdbDatatable.rows = newVal.rows;
                if(newVal.columns2 && this.$refs.mdbDatatable2) {
                    this.$refs.mdbDatatable2.columns = newVal.columns2;
                }
                if(newVal.rows2 && this.$refs.mdbDatatable2) {
                    this.$refs.mdbDatatable2.rows = newVal.rows2;
                }
            },
            columns(newVal) {
                this.$refs.mdbDatatable.columns = newVal;
            },
            rows(newVal) {
                this.$refs.mdbDatatable.rows = newVal;
            },
            columns2(newVal) {
                if(this.$refs.mdbDatatable2) {
                    this.$refs.mdbDatatable2.columns = newVal;
                }
            },
            rows2(newVal) {
                if(this.$refs.mdbDatatable2) {
                    this.$refs.mdbDatatable2.rows = newVal;
                }
            },
        },
        created() {
            let a=1;
        },
        beforeUpdate() {
            let a=1;
        },
        updated() {
            // let a=1;
            this.$nextTick(function () {
                this.$emit('updated');
            })
        },
        beforeMount() {
            let a=1;
        },
        mounted() {
            let a=1;
        },
    }
</script>

<style lang="scss">
    div#allowance-select-wrapper .dataTables_wrapper{
        padding: 0 10px !important;
    }
</style>
